// Array of color-blind safe colors to use in visualizations or other
// spots that need a large range of varied, qualitative colors.
export var VISUALIZATION_COLORS = ['#00B3A4', '#3185FC', '#DB1374', '#490092', '#FEB6DB', '#E6C220', '#F98510', '#BFA180', '#461A0A', '#920000'];
export var DEFAULT_VISUALIZATION_COLOR = VISUALIZATION_COLORS[1];